<template>
  <div class="header yxj-space">
    <div class="sys-area yxj-flex">
      <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="collapseMenu"></i>
      <span class="sys-admin">欢迎 {{ userName || "--" }}</span>
    </div>
    <div class="sys-user yxj-flex">
      <div class="header-search">
        <el-select
          v-model="searchVal"
          filterable
          remote
          :remote-method="querySearch"
          :loading="loading"
          placeholder="搜索菜单"
          @change="handleSearchSelect"
          size="small"
          class="search-select"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- <div class="logout yxj-flex mar-right" @click="logout">
        <i class="el-icon-lock out"></i>
        <span>修改密码</span>
      </div> -->
      <!-- <div class="sys-role" v-if="userId != 1">
        <span @click="showList = !showList"
          >{{ roleList.name }}<i class="el-icon-arrow-down el-icon--right"></i
        ></span>
        <ul class="sys-role-warp" v-if="showList">
          <li
            @click="toRole(item)"
            v-for="(item, index) in roleList.list"
            :key="index"
          >
            {{ item.roleName }}
          </li>
        </ul>
      </div> -->
      <div class="logout yxj-flex" @click="logout">
        <i class="el-icon-switch-button out"></i>
        <span>退出登录</span>
      </div>
    </div>
  </div>
</template>
<script>
import { Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import { setToken, getToken, removeToken, getRouters } from "../../utils/index";
import serviceApi from "../../api/serviceAPI";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "Header",
  components: { Dropdown, DropdownMenu, DropdownItem },
  data() {
    return {
      showList: false,
      searchVal: "",
      options: [],
      loading: false,
    };
  },
  computed: {
    userName() {
      return getToken("userName");
    },
    roleList() {
      return getToken("roleList");
    },
    userId() {
      return getToken("userId");
    },
    ...mapGetters({
      isCollapse: "isCollapse",
      menuList: "menuList",
    }),
    menuOptions() {
      return this.generateRoutes(this.menuList);
    },
  },
  mounted() {
    if (!this.menuList || this.menuList.length === 0) {
      this.initMenu();
    }
  },
  methods: {
    ...mapActions(["initMenu"]),
    querySearch(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          if (this.menuOptions && this.menuOptions.length > 0) {
            this.options = this.menuOptions.filter((item) => {
              return (
                item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
              );
            });
          } else {
            this.options = [];
          }
        }, 200);
      } else {
        this.options = [];
      }
    },
    generateRoutes(routes, prefix = "") {
      let res = [];
      if (!routes) return res;
      
      routes.forEach((route) => {
        if (route.hidden === "Y") return;

        const routeName = route.name || "未命名";

        // Check if it has children and if those children are not empty
        if (route.children && route.children.length > 0) {
          res = [
            ...res,
            ...this.generateRoutes(
              route.children,
              prefix + routeName + " > "
            ),
          ];
        } else {
          // Leaf node
          res.push({
            value: route.path,
            label: prefix + routeName,
          });
        }
      });
      return res;
    },
    handleSearchSelect(path) {
      if (path && this.$route.path !== path) {
        this.$router.push(path);
      }
      this.searchVal = "";
    },
    collapseMenu() {
      this.openMenu();
    },
    ...mapMutations({
      openMenu: "openMenu",
    }),
    logout() {
      serviceApi
        .goOut({})
        .then(() => {
          this.$router.push({ path: "/login" });
          removeToken("token");
          removeToken("userName");
        })
        .catch((error) => {
          this.$errorToast(error);
        });
    },
    toRole(item) {
      const params = {
        roleId: item.roleId,
        userId: this.userId,
      };
      serviceApi
        .roleCommit(params)
        .then((data) => {
          setToken("token", data.token);
          setToken("userName", data.userName);
          setToken("roleList", {
            name: item.roleName,
            list: this.roleList.list,
          });
          serviceApi
            .getMenuAndButton({})
            .then((data1) => {
              // const menuList = data1.menuList;
              // const pathRouter = getRouters(menuList, menuList);
              // this.$store.commit('setMenuAndButton', { menuList, permissions: data1.permissions });
              location.reload();
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((error) => {
          this.loading = false;
          this.$errorToast(error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  height: 100%;
}

.header-search {
  margin-right: 20px;
  .search-select {
    width: 250px;
    
    /deep/ .el-input__inner {
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      background-color: rgba(255, 255, 255, 0.9);
    }
  }
}

.sys-role {
  color: #fff;
  margin-right: 32px;
  font-size: 14px;
  position: relative;
  z-index: 99;
  width: 170px;
  text-align: right;

  .sys-role-warp {
    width: 100%;
    position: absolute;
    background-color: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(49, 49, 49, 0.1);
    top: 30px;
    max-height: 60vh;
    overflow-y: auto;

    li {
      color: gray;
      line-height: 36px;
      padding: 0 20px;
      text-align: left;
    }

    li:hover {
      color: #66b1ff;
      background-color: #ecf5ff;
    }
  }
}

.sys-area {
  i {
    font-size: 18px;
    color: #fff;
    cursor: pointer;
  }
}

.sys-text {
  font-size: 14px;
  color: #fff;
}

.sys-admin {
  margin-left: 16px;
  font-size: 14px;
  color: #fff;
}

.notify {
  font-size: 24px;
  color: #676767;
}

.sys-user {
  justify-content: flex-end;
}

.user-photo {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
}

.user-photo img {
  border-radius: 50%;
}

.user-name {
  font-size: 14px;
  color: #fff;
  margin-right: 24px;
}

.logout {
  cursor: pointer;
  color: #fff;
}

.mar-right {
  margin-right: 24px;
}

.out {
  font-size: 20px;
  margin-right: 6px;
}

.logout span {
  font-size: 14px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/layout/Header.vue